import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';
import { updateDiscipleByMap } from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';

const {
  COPY_PASTE_THERAPY_PLANNING_LOADING_2_0,
  COPY_PASTE_THERAPY_PLANNING_REQUEST_2_0,
  COPY_PASTE_THERAPY_PLANNING_SUCCESS_2_0,
  COPY_PASTE_THERAPY_PLANNING_FAILURE_2_0,
  COPY_PASTE_THERAPY_PLANNING_RESET_2_0,
  GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
} = therapyPlanningAction;

function* copyPasteTherapyPlanning_2_0(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: COPY_PASTE_THERAPY_PLANNING_LOADING_2_0 });
    const response = yield call(therapyPlanningService.copyPasteTherapyPlanning, payload?.payload);
    if (response?.status === 200) {
      yield put({
        type: COPY_PASTE_THERAPY_PLANNING_SUCCESS_2_0,
        payload: response?.data?.message,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: COPY_PASTE_THERAPY_PLANNING_FAILURE_2_0, payload: error });
  }
}

function* copyPasteTherapyPlanningSaga_2_0() {
  yield takeEvery(COPY_PASTE_THERAPY_PLANNING_REQUEST_2_0, copyPasteTherapyPlanning_2_0);
}

export default copyPasteTherapyPlanningSaga_2_0;
